import Dialog, {
  DialogActions,
  DialogContent,
  DialogTitle
} from 'material-ui-next/Dialog';
import FlatButton from 'material-ui/FlatButton';
import React from 'react';
import Joi from 'joi';
import validation from 'react-validation-mixin';
import strategy from 'joi-validation-strategy';
import dist_configs from 'zeno-config/dist.json';
import {
  FormControl,
  FormHelperText
} from 'material-ui-next/Form';
import Input, {
  InputLabel
} from 'material-ui-next/Input';
import Select from 'material-ui-next/Select';
import {
  MenuItem
} from 'material-ui-next/Menu';
import styles from './all.css';

class DeviceUpdateDialog extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      err_msg: '',
      device_data: {},
      open: false,
      dist_list: [],
      update: {
        service: '',
        system: '',
        version: '',
        platform: ''
      }
    }

    this.validatorTypes = {
      service: Joi.string()
        .required()
        .valid(dist_configs.services)
        .label('Package Name'),
      system: Joi.string()
        .required()
        .valid(dist_configs.systems)
        .label('Package System'),
      platform: Joi.string()
        .required()
        .valid(dist_configs.platforms)
        .label('Package Platform'),
      version: Joi.string()
        .required()
        .min(5)
        .max(50)
        .label('Package Version'),
    }

    this.cancel_dialog = this.cancel_dialog.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.handleBlur = this.handleBlur.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  componentDidMount() {}

  getValidatorData() {
    return this.state.update
  }

  open_update(device_data) {
    this.setState({
      err_msg: '',
      device_data: device_data,
      open: true,
      dist_list: [],
      update: {
        system: '',
        service: '',
        version: '',
        platform: ''
      }
    }, () => {
      this.props.clearValidations()
    })
  }

  cancel_dialog() {
    this.setState({
      open: false
    })
  }

  handleChange(e) {
    const target = e.target;
    var value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      update: Object.assign(
        this.state.update, {
          [name]: value
        }
      )
    });
  }

  handleBlur(e) {
    const target = e.target;
    var value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
        update: Object.assign(
          this.state.update, {
            [name]: value
          }
        )
      },
      this.props.handleValidation(name)
    )
  }

  handleSubmit(e) {
    this.props.validate((_err) => {
      if (_err) return
      this.props.confirm_update(
        this.state,
        (err) => {
          if (err) {
            this.setState({
              err_msg: err.message
            })
          } else this.setState({
            open: false
          }, () => {
            this.props.history.push('/devices/online')
          })
        }
      )
    })
  }

  renderHelperText(msg) {
    var err_msg = msg
    if (Array.isArray(msg) && msg.length > 0) {
      err_msg = msg[0]
    }
    return (
      <span styleName="">{err_msg}</span>
    )
  }

  render() {
    var update_button_text_parts = ["Update"]
    if (this.state.update.service) {
      update_button_text_parts.push(this.state.update.service)
    }
    if (this.state.update.version) {
      update_button_text_parts.push('To')
      update_button_text_parts.push(this.state.update.version)
    }
    const actions = [
      <FlatButton
        label="Cancel"
        onClick={this.cancel_dialog}
      />,
      <FlatButton
        label={update_button_text_parts.join(' ')}
        keyboardFocused={true}
        onClick={this.handleSubmit}
        disabled={!this.props.isValid()}
      />,
    ]
    const device_name = this.state.device_data.alias

    return (
      <Dialog
        open={this.state.open}
      >
        <DialogTitle>{"Update Device: " + device_name}</DialogTitle>
        <DialogContent className={styles['dev-update-dialog-content']}>
          <div>{this.state.err_msg}</div>
          <FormControl>
            <InputLabel htmlFor="service-helper">Package Name</InputLabel>
            <Select
              autoWidth
              value={this.state.update.service}
              onChange={this.handleChange}
              input={<Input name="service" id="service-helper" onBlur={this.props.handleValidation("service")}/>}
            >
              <MenuItem value="">
                <em>Not Selected</em>
              </MenuItem>
              {dist_configs.services.map((ser) => {
                 return (
                   <MenuItem key={ser} value={ser}>
                     {ser}
                   </MenuItem>
                 )
              })}
            </Select>
            <FormHelperText>
              {this.renderHelperText(this.props.getValidationMessages('service'))}
            </FormHelperText>
          </FormControl>
          <br />
          <FormControl>
            <InputLabel htmlFor="system-helper">Package System</InputLabel>
            <Select
              autoWidth
              value={this.state.update.system}
              onChange={this.handleChange}
              input={<Input name="system" id="system-helper" onBlur={this.props.handleValidation("system")}/>}
            >
              <MenuItem value="">
                <em>Not Selected</em>
              </MenuItem>
              {dist_configs.systems.map((ser) => {
                 return (
                   <MenuItem key={ser} value={ser}>
                     {ser}
                   </MenuItem>
                 )
              })}
            </Select>
            <FormHelperText>
              {this.renderHelperText(this.props.getValidationMessages('system'))}
            </FormHelperText>
          </FormControl>
          <br/>
          <FormControl>
            <InputLabel htmlFor="platform-helper">Package Platform</InputLabel>
            <Select
              autoWidth
              value={this.state.update.platform}
              onChange={this.handleChange}
              input={<Input name="platform" id="platform-helper" onBlur={this.props.handleValidation("platform")}/>}
            >
              <MenuItem value="">
                <em>Not Selected</em>
              </MenuItem>
              {dist_configs.platforms.map((ser) => {
                 return (
                   <MenuItem key={ser} value={ser}>
                     {ser}
                   </MenuItem>
                 )
              })}
            </Select>
            <FormHelperText>
              {this.renderHelperText(this.props.getValidationMessages('platform'))}
            </FormHelperText>
          </FormControl>
          <br/>
          <FormControl>
            <InputLabel htmlFor="version-helper">Package Version</InputLabel>
            <Input
              name="version"
              id="version-helper"
              value={this.state.update.version}
              onChange={this.handleChange}
              onBlur={this.handleBlur}
            />
            <FormHelperText>
              {this.renderHelperText(this.props.getValidationMessages('version'))}
            </FormHelperText>
          </FormControl>
          <br/>
        </DialogContent>
        <DialogActions>
          {actions}
        </DialogActions>
      </Dialog>
    )
  }
}

DeviceUpdateDialog.defaultProps = {
  confirm_update: null,
  history: null
}

export default validation(strategy)(DeviceUpdateDialog)



// WEBPACK FOOTER //
// ./src/views/devices/update_dialog.react.js